const createProjectFragment = () => `
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

export default createProjectFragment;
